import 'lazysizes';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import $ from 'jquery';
import Slick from './slick';

export default {
    init() {
        const $scriptTag = $('.main script:not([type="application/javascript"])');
        if ($scriptTag.length) $scriptTag.attr('type', 'application/javascript');

        const $styleTag = $('.main style');
        if ($styleTag.length) {
            $styleTag.appendTo('#plugin-styles');
        }

        Slick.init();
    },
};
